export const pageRoutes = {
  home: "/",
  register: "/register",
  login: "/login",
  patientLogin: "/patientlogin",
  forgotPassword: "/resetpassword",
  checkInChat: "/checkinchat",
  checkInSpeak: "/checkinspeak",
  dashboard: "/dashboard",
  doctorpatients: "/doctor-patients",
  dashboardPatient: "/dashboardpatient",
  scheduleAppointment: "/scheduleappointment",
  viewAppointments: "/viewappointments",
  info: "/info",
  landing: "/landing",
  docaideMindChat: "/docaidemindchat",
  docaideMindSpeak: "/docaidemindspeak",
  therapyChat: "/therapychat",
  therapySpeak: "/therapyspeak",
  selectUser: "/selectuser",
  dashboardPatientList: "/dashboardpatientlist",
  adminDashboardHospitalList: "/admindashboardhospitallist",
  providerList: "/provider-list",
  adminDashboardPatientList: "/admindashboardpatientlist",
  adminDashboardAppointmentList: "/admindashboardappointmentlist",
  docaideLaunch2: "/launchdocaide2",
  docaideLaunch3: "/launchdocaide3",
  emergency: "/emergency",
  newPatient: "/newpatient",
  adminDashboardNewPatient: "/admindashboardnewpatient",
  adminDocaideLaunch2: "/admindocaidelaunch2",
  adminDocaideLaunch3: "/admindocaidelaunch3",
  adminDashboardEditPatient: "/admindashboardeditpatient",
  editPatient: "/editpatient",
  frontDeskLogin: "/frontdesklogin",
  patientWelcome: "/patientwelcome",
  reduxPage: "/redux-page",
  //patientDetails: "/patientdetails",
  viewAppointmentDetails: "/view-appointment-details",
  updatePatientDetails: "/update-patient-details",
  addNewPatient: "/add-new-patient",
  nurseList: "/nurse-list",
  nurseAppointmentList: "/nurse-appointment-list",
  nursePatientRecord: "/nurse-patient-record",
  //nursePatientVitals: "/nursepatientvitals",
  //nursePatientPharmacy: "/nursePatientPharmacy",
  admissionForm: "/admisson-form",
};
